import React from 'react';
import { motion } from 'framer-motion';
const testimonials = [{
  quote: 'Organicé todo mi protocolo de diagnóstico en un solo fin de semana. Ahora sé exactamente qué rastrear cuando un paciente llega con ansiedad o bloqueos económicos. Dejé de adivinar en sesión y mis pacientes notan la diferencia en su cuerpo desde la primera semana.',
  author: 'Lic. Mariana T.',
  location: 'Buenos Aires',
  role: 'Psicóloga Clínica Sistémica'
}, {
  quote: 'El Kit de guiones verbales (Script Book) cambió mi consulta. Logré que una paciente destrabara un síntoma físico de colon irritable en solo 3 sesiones, después de que llevaba un año estancada en terapia verbal tradicional. El cruce con la biodecodificación es milagroso.',
  author: 'Facundo R.',
  location: 'Rosario',
  role: 'Terapeuta Transpersonal'
}, {
  quote: 'Diseño la sesión de diagnóstico cruzado según la apertura del paciente en 5 minutos. Antes me pasaba horas investigando en libros y videos cómo integrar el árbol genealógico con el dolor del síntoma físico de manera profesional.',
  author: 'Valentina F.',
  location: 'Córdoba',
  role: 'Psicopedagoga y Consteladora Familiar'
}];
export const Testimonials = () => {
  return <section className="py-24 bg-cream relative" data-id="element-281">
      <div className="container mx-auto px-6" data-id="element-282">
        <div className="text-center mb-16" data-id="element-283">
          <p className="text-gold-600 font-serif text-xl italic mb-4" data-id="element-284">
            Lo que dicen los profesionales que ya lo aplican:
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-285">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-cream-100 p-8 rounded-sm border border-gold-500/20 shadow-sm relative" data-id="element-286">
              <div className="absolute -top-4 -left-2 text-6xl text-gold-500/20 font-serif" data-id="element-287">
                "
              </div>
              <blockquote className="text-navy/80 italic mb-6 relative z-10 leading-relaxed" data-id="element-288">
                "{t.quote}"
              </blockquote>
              <div className="border-t border-gold-500/20 pt-4" data-id="element-289">
                <p className="font-serif font-bold text-navy text-lg" data-id="element-290">
                  {t.author}
                </p>
                <p className="text-sm text-navy/60" data-id="element-291">
                  {t.location} — {t.role}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};